import type { BreadcrumbFragment, RouteQuery } from '#graphql-operations'

type UseBreadcrumb = {
  links: ComputedRef<BreadcrumbFragment[]>
  setLinksFromRoute: (query?: RouteQuery | undefined | null) => void
  setLinks: (links?: BreadcrumbFragment[]) => void
}

/**
 * Extract the breadcrumb from a route query.
 */
function getBreadcrumbFromRouteQuery(
  routeQuery: RouteQuery | undefined | null,
): BreadcrumbFragment[] | undefined {
  if (!routeQuery) {
    return
  }

  if (!routeQuery.route) {
    return
  }

  if ('entity' in routeQuery.route && routeQuery.route.entity) {
    const entity = routeQuery.route.entity
    // These two pages don't display a breadcrumb.
    if (
      'isFrontPage' in entity &&
      (entity.isChannelLandingPage || entity.isFrontPage)
    ) {
      return
    }
  }

  if (!('breadcrumb' in routeQuery.route)) {
    return
  }

  return routeQuery.route.breadcrumb || []
}

/**
 * Returns the current breadcrumb links.
 */
export function useBreadcrumb(): UseBreadcrumb {
  const breadcrumb = useState<BreadcrumbFragment[]>('breadcrumbLinks', () => [])

  function setLinksFromRoute(query?: RouteQuery | null | undefined) {
    breadcrumb.value = getBreadcrumbFromRouteQuery(query) || []
  }

  function setLinks(links?: BreadcrumbFragment[]) {
    breadcrumb.value = links || []
  }

  return {
    links: computed(() => breadcrumb.value),
    setLinks,
    setLinksFromRoute,
  }
}
